/* Lot 5: custom dataLayer events only. GTM owns tags/consent and standard ecommerce. */
(() => {
  'use strict';
  if (window.PBCroAnalytics) return;
  const contextNode = document.querySelector('[data-pb-analytics-context]');
  let context = {};
  try { context = JSON.parse(contextNode?.textContent || '{}'); } catch (_) {}
  const fields = {
    routine_click:['routine_id','location','action'], routine_filter:['filter_name','filter_value','location'],
    routine_format_select:['routine_id','format','location'], routine_add_success:['routine_id','format','location','items_added','value'], routine_add_error:['routine_id','location'],
    search_no_results:['search_term'], filter_apply:['filter_name','filter_value','collection'],
    shade_select:['product_id','shade_code','location'], set_add:['product_id','items_added','value'], set_discount_missing:['product_id'],
    back_in_stock_subscribe:['product_id','variant_id'], faq_open:['product_id','brand'],
    range_products_click:['product_id','location'], service_request_click:['product_id'],
    gift_threshold_view:['threshold'], gift_add:['threshold']
  };
  const ids = v => /^\d+$/.test(String(v || ''));
  const clean = v => String(v ?? '').replace(/[\x00-\x1f]/g,' ').trim().slice(0,150);
  const seen = new Set();
  function emit(event, params = {}) {
    if (!fields[event]) return false;
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (event.startsWith('routine_') && privacy?.analyticsProcessingAllowed?.() !== true) return false;
      if (privacy?.analyticsProcessingAllowed && !privacy.analyticsProcessingAllowed()) return false;
      const payload = {event};
      for (const key of fields[event]) {
        if (params[key] === undefined || params[key] === '') continue;
        if (['value','items_added','threshold'].includes(key)) {
          if (!Number.isFinite(params[key]) || params[key] < 0) return false;
          payload[key] = params[key];
        } else payload[key] = clean(params[key]);
      }
      if ('product_id' in payload && !ids(payload.product_id) || 'variant_id' in payload && !ids(payload.variant_id)) return false;
      // Search fields are free text: never intentionally send addresses or phone numbers.
      if (event === 'search_no_results' && (!payload.search_term || /@|\+?\d[\d\s().-]{7,}\d/.test(payload.search_term))) return false;
      if (event === 'shade_select' && (!ids(payload.product_id) || !payload.shade_code || !['card','pdp','sticky'].includes(payload.location))) return false;
      if (event === 'set_discount_missing' && !ids(payload.product_id)) return false;
      if (event === 'set_add' && (!ids(payload.product_id) || !Number.isInteger(payload.items_added) || payload.items_added < 1 || payload.value === undefined)) return false;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      return true;
    } catch (_) { return false; } // Analytics must never block shopping.
  }
  function once(key, event, params) {
    if (seen.has(key)) return false;
    if (!emit(event,params)) return false;
    seen.add(key);return true;
  }
  let previousFilters = new URLSearchParams(location.search);
  function searchResults(term, count) {
    if (Number(count) !== 0) return;
    once('search:'+clean(term),'search_no_results',{search_term:term});
  }
  function filtersApplied(searchParams, html) {
    const next = new URLSearchParams(searchParams);
    // Ignore responses from a superseded request, and back/forward or initial hydration.
    const current = new URLSearchParams(location.search);
    const signature = p => [...p].filter(([k,v])=>k.startsWith('filter.') && v).sort().map(x=>JSON.stringify(x)).join('|');
    if (signature(current) !== signature(next)) return;
    for (const [name,value] of next) {
      if (!name.startsWith('filter.') || !value || previousFilters.getAll(name).includes(value)) continue;
      emit('filter_apply',{filter_name:name,filter_value:value,collection:context.collection || ''});
    }
    previousFilters = next;
    if (context.page_type === 'search' && typeof html === 'string') {
      const doc = new DOMParser().parseFromString(html,'text/html');
      const count = doc.querySelector('[data-total-count]')?.getAttribute('data-total-count');
      if (count !== null && count !== undefined) searchResults(next.get('q'),count);
    }
  }
  function backInStockSubscribed(detail) {
    if (detail?.success !== true || !ids(detail.product_id) || !ids(detail.variant_id)) return false;
    return once(`bis:${detail.product_id}:${detail.variant_id}`,'back_in_stock_subscribe',{product_id:detail.product_id,variant_id:detail.variant_id});
  }
  window.PBCroAnalytics = {emit,filtersApplied,searchResults,backInStockSubscribed};
  document.addEventListener('pb-cro:back-in-stock-subscribed',e=>backInStockSubscribed(e.detail));
  // A future Globo adapter must call filtersApplied only after a successful filter response.
  window.addEventListener('popstate',()=>{previousFilters=new URLSearchParams(location.search);});
  document.addEventListener('toggle',e=>{
    const node=e.target;
    if (!node.matches?.('[data-pb-faq]') || !node.open) return;
    if (ids(node.dataset.productId)) emit('faq_open',{product_id:node.dataset.productId});
    else if (node.dataset.brand) emit('faq_open',{brand:node.dataset.brand});
  },true);
  document.addEventListener('click',e=>{
    const link=e.target.closest?.('a');if(!link)return;
    if (link.matches('[data-pb-range-all]')) emit('range_products_click',{product_id:link.dataset.productId,location:'vezi-toata-gama'});
    const range=link.closest('[data-pb-range-product]');
    if(range && new URL(link.href,location.origin).pathname.includes('/products/')) emit('range_products_click',{product_id:range.dataset.pbRangeProduct});
    if(link.matches('[data-pb-service-product]')) emit('service_request_click',{product_id:link.dataset.pbServiceProduct});
  });
  let observer;
  if ('IntersectionObserver' in window) observer=new IntersectionObserver(entries=>{
    for(const entry of entries){
      if(!entry.isIntersecting || entry.intersectionRatio<0.5 || !entry.target.getClientRects().length)continue;
      const thresholds=entry.target.dataset.campaignActive==='true'?[250,350,500]:[250];
      for(const threshold of thresholds)once('threshold:'+threshold,'gift_threshold_view',{threshold});
    }
  },{threshold:0.5});
  const watched=new WeakSet();
  function scan(){document.querySelectorAll('.pb-cro-cart-goals').forEach(el=>{if(!watched.has(el)){watched.add(el);observer?.observe(el);}});}
  function initial(){
    if(context.page_type==='search' && context.search_performed)searchResults(context.search_term,context.search_count);
    scan();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initial,{once:true});else initial();
  document.addEventListener('visitorConsentCollected',initial);
  document.addEventListener('eurus:cart:items-changed',scan);
  document.addEventListener('shopify:section:load',scan);
})();
